import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col, notification } from "antd";
import ReactQuill from "react-quill";
import moment from "moment";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import {
  addeditSetting,
  settingList,
} from "../../../controllers/V1/cms/campaignController";
import "react-quill/dist/quill.snow.css";
import "react-datepicker/dist/react-datepicker.css";
import { ASSETS_BASE_URL } from "../../../config/constants";
import UploadImage from "../products/UploadImge";
import { Image } from "antd";
import Loading from "../../../components/Loading/LoadingEffect";
const { Option } = Select;

const SettingAddEdit = () => {
  const location = useLocation();
  const state = location.state; // State for edit mode
  const [isLoading, setIsLoading] = useState(true);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [listData, setListData] = useState("");
  const [initialValues, setInitialValues] = useState("");
  const [showNumberRangePrefix, setShowNumberRangePrefix] = useState(true);
  // Set initial form values for edit mode
  const [ADDEDITDATA, setAddEditData] = useState(state || []);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [childData, setChildData] = useState("");
  const handleUploadImage = () => setIsOpenUpload(!isOpenUpload);

  const handleChildData = (data) => {
    setChildData(data);
    if (data?._id) {
      setAddEditData((prevState) => ({
        ...prevState,
        game_rule_image: data?.url || "",
      }));
      form.setFieldsValue({ game_rule_image: data?.url || "" }); // Update the form's image field
    }
  };

  //New Image Uploader
  const [showUploader, setShowUploader] = useState(false);
  const toggleImgUploader = () => setShowUploader(!showUploader);
  const [imageUrl, setImageUrl] = useState(state?.image || "");
  //   end

  const getSettingList = async () => {
    try {
      setListData([]);
      const options = {
        type: "single",
        condition: {
          ...(state?._id ? { campaign_data: state._id } : {}),
          setting_type: state === "Global" ? state : "Campaign",
        },
      };
      const listData = await settingList(options);
      if (listData.status === true) {
        setListData(listData?.result);
        setInitialValues(listData?.result);
      }
      setIsLoading(false);
    } catch (error) { setIsLoading(false); }
  }; //End

  const handleSubmit = async (values) => {
    try {
      const formattedValues = {
        ...values,
        ...(state !== "Global"
          ? {
              campaign_id:
                state?._id || initialValues?.campaign_data?._id || undefined,
            }
          : {}), // Pass ID in edit mode
        setting_type: state === "Global" ? state : "Campaign",
        ...(listData?._id && { editId: listData?._id }),
      };
      const res = await addeditSetting(formattedValues);
      if (res.status === true) {
        notification.success({
          message: "Success",
          description: "Data successfully added/updated.",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        navigate("/campaign/list");
      } else {
        notification.error({
          message: "Error",
          description: res.message,
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

  useEffect(() => {
    form.setFieldsValue(initialValues); // Populate form fields
  }, [initialValues, form]);

  useEffect(() => {
    if (state?.enable_number_range_prefix === "N") {
      setShowNumberRangePrefix(false);
    }
    document.title = `Crown-King || campaign's setting ${
      listData?._id ? "edit" : "add"
    }`;
    getSettingList();
  }, [state]);

  return (
    <div className="container-fluid">
      <div className="Inventory_edit_page_main_div">
        <h5 className="inventory_edit_page_heading">
          {listData?._id ? "Edit" : "Add"} Campaign Setting
        </h5>
        <Link to="/campaign/list">
          <Button type="secondary">
            <ArrowLeftOutlined /> Back
          </Button>
        </Link>
      </div>

      <div className="card shadow mb-4 dataBase_table_Add_Data">
        <div style={{ padding: "20px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={initialValues}
            // onValuesChange={handleValuesChange}
          >
            {/* <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Setting Type"
              name="setting_type"
              rules={[{ required: true, message: "Setting Type is required" }]}
            >
              <Input  />
            </Form.Item>
          </Col>
        </Row> */}
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Campaign Settings"
                  name="campaign_auto_freezing_mode"
                >
                  <Select>
                    <Option value="Enable">Enable</Option>
                    <Option value="Disable">Disable</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Freezing Start Time"
                  name="campaign_freezing_start_time"
                >
                  <Input type="time" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Freezing End Time"
                  name="campaign_freezing_end_time"
                >
                  <Input type="time" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Straight Game Name" name="straight_game_name">
                  <Input placeholder="Straight Game Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Straight Settings" name="straight_settings">
                  <Select>
                    <Option value="Enable">Enable</Option>
                    <Option value="Disable">Disable</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Straight Default Check"
                  name="straight_settings_default_check"
                >
                  <Select>
                    <Option value="Checked">Checked</Option>
                    <Option value="Unchecked">Unchecked</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Repeat similar blocks for Rumble and Chance settings */}

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Rumble Game Name" name="rumble_game_name">
                  <Input placeholder="Rumble Game Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Rumble Settings" name="rumble_settings">
                  <Select>
                    <Option value="Enable">Enable</Option>
                    <Option value="Disable">Disable</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Rumble Default Check"
                  name="rumble_settings_default_check"
                >
                  <Select>
                    <Option value="Checked">Checked</Option>
                    <Option value="Unchecked">Unchecked</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Chance Game Name" name="chance_game_name">
                  <Input placeholder="Chance Game Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Chance Settings" name="chance_settings">
                  <Select>
                    <Option value="Enable">Enable</Option>
                    <Option value="Disable">Disable</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Chance Default Check"
                  name="chance_settings_default_check"
                >
                  <Select>
                    <Option value="Checked">Checked</Option>
                    <Option value="Unchecked">Unchecked</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label="Game Description" name="game_description">
                  <ReactQuill />
                  {/* <Input.TextArea rows={4} placeholder="Enter description" /> */}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Game Rule Image"
                  name="game_rule_image"
                  rules={[{ required: true, message: "Image is required!" }]}
                >
                  <div>
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={handleUploadImage}
                    >
                      Select
                    </button>
                    <span>{childData?.url}</span>
                    {initialValues?.game_rule_image && (
                      <Image
                        width={100}
                        src={`${ASSETS_BASE_URL}${initialValues.game_rule_image}`}
                      />
                    )}
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <div className="text-center">
              <div class="verndor_dashboard_add_edit_button">
                <button
                  type="submit"
                  class="btn btn-primary inventory_save_button"
                >
                  Save
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <UploadImage
        openUpload={isOpenUpload}
        toggleUploadOpen={handleUploadImage}
        onSendData={handleChildData}
      />
      <Loading isLoading={isLoading} />
    </div>
  );
};

export default SettingAddEdit;
